// extracted by mini-css-extract-plugin
export default {"container":"InspectionCompletePage_container__2x0RN"};